import ServiceService from '_services/rest/modules/service';

export default {
  state: {
    serviceList: null,
    serviceEdit: null,
  },
  mutations: {
    setService(state, response) {
      state.serviceEdit = response;
    },
    setServiceList(state, response) {
      state.serviceList = response;
    },
  },
  actions: {
    getServiceList({ commit }, params) {
      return ServiceService.getList(params)
        .then(response => {
          commit('setServiceList', response);
        });
    },

    getService({ commit }, params) {
      return ServiceService.getServiceById(params)
        .then(response => {
          commit('setService', response);
          return response;
        });
    },
  },
};
